import React, { useState } from "react";
import Modal from "Components/Molecules/Modal";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Box from "Components/Atoms/Box";
import Typography from "Components/Atoms/Typography";
import firebase, { db } from "utils/firebase";
import { Switch, FormControlLabel } from "@material-ui/core";
import Select from "Components/Atoms/Select";
import "./styles.scss";

type CreateAlertModalProps = {
  open: boolean;
  onClose: () => void;
  restaurantId: string;
};

const CreateAlertModal: React.FC<CreateAlertModalProps> = ({
  open,
  onClose,
  restaurantId,
}) => {
  const [description, setDescription] = useState<string>("");
  const [isGeneral, setIsGeneral] = useState(false);
  const [severity, setSeverity] = useState<"error" | "warning" | "info">(
    "error"
  );
  const [submitting, setsubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!description || description.replace(/<[^>]+>/g, "").trim() === "")
      return;

    try {
      setsubmitting(true);

      const alertData = {
        description,
        isGeneral,
        restaurantId: isGeneral ? "" : restaurantId,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        severity,
      };

      await db.collection("dashboardAlertMessages").add(alertData);

      setDescription("");
      setIsGeneral(false);
      onClose();
    } catch (error) {
      console.error("Error creating alert:", error);
    } finally {
      setsubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={
        isGeneral ? "Globalen Alert erstellen" : "Restaurant-Alert erstellen"
      }
      titleTranslation="adminNotes"
      maxWidth="sm"
      fullWidth
      severity="info"
      onSubmit={handleSubmit}
      actions={[
        {
          id: "cancel",
          label: "Abbrechen",
          variant: "default",
          translation: "common",
        },
        {
          id: "create",
          label: "Alert erstellen",
          translation: "adminNotes",
          variant: "primary",
          submit: true,
          loading: submitting,
          disabled:
            !description || description.replace(/<[^>]+>/g, "").trim() === "",
        },
      ]}
    >
      <Box flex column style={{ gap: 16 }}>
        <div style={{ width: "100%" }}>
          <Typography
            translation="adminNotes"
            variant="text-4"
            component="label"
          >
            Beschreibung *
          </Typography>
          <ReactQuill
            value={description}
            onChange={setDescription}
            theme="snow"
            className="alert-editor"
            modules={{
              toolbar: [
                [{ header: [false, 2, 3] }],
                ["bold", "italic", "underline"],
                [{ list: "bullet" }, { list: "ordered" }],
                ["link"],
                ["clean"],
              ],
            }}
          />
        </div>
        {/* Severity selection */}
        <Select
          label="Schweregrad"
          translation="adminNotes"
          fullWidth
          value={severity}
          onChange={(e) =>
            setSeverity(
              (e.target as HTMLInputElement).value as
                | "error"
                | "warning"
                | "info"
            )
          }
          options={[
            { id: "error", label: "Hoch (Fehler)" },
            { id: "warning", label: "Mittel (Warnung)" },
            { id: "info", label: "Niedrig (Informationen)" },
          ]}
        />
        <FormControlLabel
          control={
            <Switch
              checked={isGeneral}
              onChange={(e) => setIsGeneral(e.target.checked)}
              color="primary"
            />
          }
          label={
            <Typography translation="adminNotes" variant="text-4">
              Allgemeiner Alert (gilt für alle Restaurants)
            </Typography>
          }
        />
      </Box>
    </Modal>
  );
};

export default CreateAlertModal;
